import React, { useEffect, useState } from "react";
import { useForm } from "react-hook-form";
import { useDispatch, useSelector } from "react-redux";
import toast from "react-hot-toast";
import {
  createSubSection,
  updateSubSection,
} from "../../../../../services/operations/courseDetailsAPI";
import { setCourse } from "../../../../../slices/courseSlice";
import Upload from "../CourseForm/Upload";
import { MdCancel } from "react-icons/md";
import IconBtn from "../CourseForm/IconButton";

function SubSectionModal({
  modalData,
  setModalData,
  add = false,
  view = false,
  edit = false,
}) {
  // use form hook
  const {
    register,
    handleSubmit,
    setValue,
    getValues,
    formState: { errors },
  } = useForm();

  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const { token } = useSelector((state) => state.auth);
  const { course } = useSelector((state) => state.course);

  useEffect(() => {
    if (view || edit) {
      // you can only view and edit is the subsection is created
      setValue("lectureTitle", modalData.title);
      setValue("lectureDesc", modalData.description);
      setValue("lectureVideo", modalData.videoUrl);
    }
    // console.log("ModalData",modalData)
  });

  const isFormUpdated = () => {
    const currentValues = getValues();
    if (
      currentValues.lectureTitle !== modalData.title ||
      currentValues.lectureDesc !== modalData.description ||
      currentValues.lectureVideo !== modalData.videoUrl
    ) {
      return true;
    } else {
      return false;
    }
  };

  // Function handleEditSubSection is used to edit subsection we are creating
  /*
  an formData using useForm hook and we are appending 
  value in the form data
  and we are checking if some of the data is changes we are going to update it
*/
  async function handleEditSubSection() {
    const currentValues = getValues();

    const formData = new FormData();
    formData.append("sectionId", modalData.sectionID);
    formData.append("subSectionId", modalData._id);
    // console.log("Section id modal:",modalData.sectionID)
    if (currentValues.lectureTitle !== modalData.title) {
      formData.append("title", currentValues.lectureTitle);
    }

    if (currentValues.lectureDesc !== modalData.description) {
      formData.append("description", currentValues.lectureDesc);
    }

    if (currentValues.lectureVideo !== modalData.videoUrl) {
      formData.append("video", currentValues.lectureVideo);
    }
    setLoading(true);
    const result = await updateSubSection(formData, token);
    if (result) {
      // console.log("Form data: ",formData)
      // console.log("result", result)
      // update the structure of course
      const updatedCourseContent = course.courseContent.map((section) =>
        section._id === modalData.sectionID ? result : section
      );
      const updatedCourse = { ...course, courseContent: updatedCourseContent };
      dispatch(setCourse(updatedCourse));
    }
    setModalData(null);
    setLoading(false);
  }

  // Function will be called when the form is submitted it will contain data about the form data in parameter
  async function onSubmit(data) {
    if (view) {
      return;
    }
    if (edit) {
      if (!isFormUpdated()) {
        toast.error("No changes made to the form");
      } else {
        handleEditSubSection();
      }
      return;
    }

    // Adding data
    const formData = new FormData();
    // modalData has section id because we have passed it from the nested view
    formData.append("sectionId", modalData);
    formData.append("title", data.lectureTitle);
    formData.append("description", data.lectureDesc);
    formData.append("video", data.lectureVideo); // check video or videoURL
    setLoading(true);

    /*
      Issue and how it was fixed
      issue was when we were deleting any section it was getting deleted but the
      ui was not getting re rendered because in the course slice we were adding the data
      of section but course cannot be updated using section it will need
      an course data to be updated so what we did was 
      to create and updated course by removing the data and replacing it with new data
      and then copying previous data and adding new courseContent Data
    */

    //   API Call
    const result = await createSubSection(formData, token);

    if (result) {
      // Todo: check for updations
      const updatedCourseContent = course.courseContent.map(
        (section) => (section._id === modalData ? result : section)
        // here modalData contains section id we have appended it in the course builder form
      );
      // courseContent is array in course model which contains sections
      const updatedCourse = { ...course, courseContent: updatedCourseContent };
      // course has previous data courseContent now stores updated data
      dispatch(setCourse(updatedCourse));
    }
    setModalData(null);
    setLoading(false);
  }

  return (
    <div>
      <div className="fixed inset-0 z-[1000] !mt-0 grid place-items-center overflow-auto bg-richblack-900 bg-opacity-10 backdrop-blur-sm max-[450px]:-translate-x-0">
        <div className="flex gap-x-2 translate-y-8 max-[450px]:translate-y-10">
          {/* View add and edit flag was sent for this use also */}
          <p className="text-2xl">
            {view && "Viewing"} {add && "Adding"} {edit && "Editing"} Lecture
          </p>
          <button onClick={() => (!loading ? setModalData(null) : {})}>
            <MdCancel />
          </button>
        </div>
        {/* form */}
        <form onSubmit={handleSubmit(onSubmit)}>
          <Upload
            name="lectureVideo"
            label="Lecture Video"
            register={register}
            setValue={setValue}
            errors={errors}
            video={true}
            viewData={view ? modalData.videoUrl : null}
            editData={edit ? modalData.videoUrl : null}
          />
          <div className="mt-5 flex flex-col gap-y-1">
            <label htmlFor="lectureTitle" className="">
              Lecture Title <sup className="text-pink-200">*</sup>
            </label>
            <input
              type="text"
              id="lectureTitle"
              placeholder="Enter lecture title"
              {...register("lectureTitle", { required: true })}
              className="form-style pl-2 w-full bg-richblack-700 text-richblack-50 py-2 px-2 rounded-md border-b border-richblack-500"
            />
            {errors.lectureTitle && (
              <span className="text-richblack-100">
                Lecture title is required
              </span>
            )}
          </div>
          <div className="mt-5 flex flex-col gap-y-2">
            <label htmlFor="">
              Lecture Description <sup className="text-pink-200">*</sup>
            </label>
            <textarea
              name="lectureDesc"
              id="lectureDesc"
              cols="30"
              rows="10"
              placeholder="Enter lecture description"
              {...register("lectureDesc", { required: true })}
              className="resize-none text-richblack-50 w-full h-32 bg-richblack-700 py-2 px-4 rounded-md border-b border-richblack-500"></textarea>
            {errors.lectureDesc && (
              <span className="text-richblack-100">
                Lecture Description is requried
              </span>
            )}
          </div>
          <div>
            {!view && (
              <div className="mt-5 flex">
                <IconBtn
                  text={loading ? "Loading.." : edit ? "Save Changes" : "Save"}
                />
              </div>
            )}
          </div>
        </form>
      </div>
    </div>
  );
}

export default SubSectionModal;
